class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

// Battito cadeau-logica.
// Eén gratis variant (data-gift-free-variant-id, prijs €0,00) die automatisch
// wordt toegevoegd zodra gift_threshold is bereikt en weer verwijderd zodra de
// kar er weer onder zakt. Een eventueel los (via de eigen productpagina)
// gekocht betaald exemplaar telt gewoon mee voor de drempel (zie
// cart-gift-progress-bar.liquid / cart-gift-box.liquid) en blijft altijd
// gewoon staan: zodra de drempel wordt gehaald komt het gratis exemplaar er
// via de "add"-actie hieronder gewoon BIJ (nooit een omzetting van betaald
// naar gratis), zodat je bv. 1 betaald + 1 gratis = 2 stuks krijgt.
//
// Sinds de betaalde Kalender ook los in grotere aantallen gekocht kan worden,
// werkt de auto-sync hieronder op de EXACTE aantallen (data-gift-paid-qty /
// data-gift-free-qty) in plaats van op de oudere, dubbelzinnige
// data-gift-variant-in-cart (die uitgaat van maximaal 1 relevant stuk totaal).
// Zo blijft dit correct werken wanneer er 2 of meer stuks Kalender tegelijk in
// de kar zitten (zie snippets/cart-drawer.liquid en snippets/cart-gift-box.liquid).
//
// Het gratis exemplaar mag NOOIT meer dan 1 stuk zijn, in geen enkele
// situatie (ook niet als het via een andere weg -- bv. de losse /cart-pagina,
// zie sections/main-cart-items.liquid -- toch zou zijn opgehoogd): de
// "clamp"-actie hieronder corrigeert dat zodra dat gedetecteerd wordt, en de
// "remove"-actie verwijdert het gratis exemplaar altijd volledig (naar 0)
// zodra de kar niet meer aan de drempel voldoet, ongeacht hoeveel gratis
// stuks er per ongeluk zouden staan.

function battitoGetSections(cartDrawer) {
  return cartDrawer.getSectionsToRender().map(function(s) { return s.id; }).join(',');
}

function battitoCartAdd(variantId) {
  return fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
    body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
  });
}

function battitoCartUpdate(updates, attributes, sectionsToRender) {
  return fetch(window.Shopify.routes.root + 'cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
    body: JSON.stringify({
      updates: updates || {},
      attributes: attributes || {},
      sections: sectionsToRender,
      sections_url: window.location.pathname
    })
  });
}

function battitoRender(cartDrawer, response) {
  return response.json().then(function(state) { cartDrawer.renderContents(state); });
}

// Toggle: de klant zet het gratis cadeau zelf aan of uit (alleen mogelijk
// zodra de drempel is bereikt; de checkbox is disabled zolang dat niet zo is).
// Deze toggle zit alleen in de zichtbare (niet-verborgen) upsell-kaart, dus is
// sowieso niet bedienbaar zolang er een samengevoegde regel van 2+ stuks getoond wordt.
document.addEventListener('change', function(event) {
  if (event.target.id !== 'cart-gift-toggle') return;

  var variantId = event.target.getAttribute('data-variant-id');
  var isAdding = event.target.checked;
  var cartDrawer = document.querySelector('cart-drawer');
  if (!cartDrawer || !cartDrawer.getSectionsToRender) return;
  var sectionsToRender = battitoGetSections(cartDrawer);

  if (isAdding) {
    battitoCartAdd(variantId)
      .then(function() {
        return battitoCartUpdate({}, { gift_declined: '', gift_origin: 'manual' }, sectionsToRender);
      })
      .then(function(response) { return battitoRender(cartDrawer, response); })
      .catch(function(error) { console.error('Fout bij updaten winkelmand:', error); });
  } else {
    var container = document.querySelector('.cart-upsell-container');
    var variantInCart = container ? container.getAttribute('data-gift-variant-in-cart') : '';
    var removeVariantId = variantId;
    if (container && variantInCart === 'free') {
      removeVariantId = container.getAttribute('data-gift-free-variant-id');
    } else if (container && variantInCart === 'paid') {
      removeVariantId = container.getAttribute('data-gift-paid-variant-id');
    }

    var updates = {};
    updates[removeVariantId] = 0;

    battitoCartUpdate(updates, { gift_declined: 'true', gift_origin: '' }, sectionsToRender)
      .then(function(response) { return battitoRender(cartDrawer, response); })
      .catch(function(error) { console.error('Fout bij updaten winkelmand:', error); });
  }
});

// Automatisch synchroniseren, draait na elke wijziging van de kar:
// - toevoegen (gratis variant) zodra de drempel gehaald wordt, of dat nu met
//   0 of met 1 of meer betaalde exemplaren in de kar gebeurt: het gratis
//   exemplaar komt er dan gewoon BIJ, betaalde exemplaren blijven altijd
//   gewoon staan (dus 1 betaald + drempel gehaald wordt 1 betaald + 1 gratis
//   = 2 stuks, nooit een omzetting);
// - vastzetten op precies 1 gratis exemplaar zolang de drempel gehaald
//   blijft, mocht er via een andere weg toch meer dan 1 gratis stuk in de kar
//   terecht zijn gekomen;
// - verwijderen (volledig, naar 0, ongeacht hoeveel stuks) zodra de kar niet
//   meer aan de drempel voldoet, ook als de klant het cadeau zelf had
//   (terug)gezet — onder de drempel bestaat de gratis variant nooit, en een
//   eerdere weigering (gift_declined) wordt gereset zodat de volgende keer
//   dat de drempel wordt gehaald het cadeau weer vanzelf terugkomt. Dat
//   resetten gebeurt ook als de klant al weigerde vóórdat de kar onder de
//   drempel zakte (dus zonder dat er nog iets te verwijderen viel).
var battitoSyncInProgress = false;

function battitoSyncGift() {
  if (battitoSyncInProgress) return;

  var container = document.querySelector('.cart-upsell-container');
  if (!container) return;

  var giftReached = container.getAttribute('data-gift-threshold-reached') === 'true';
  var giftDeclined = container.getAttribute('data-gift-declined') === 'true';
  var freeVariantId = container.getAttribute('data-gift-free-variant-id');
  var paidQty = parseInt(container.getAttribute('data-gift-paid-qty'), 10) || 0;
  var freeQty = parseInt(container.getAttribute('data-gift-free-qty'), 10) || 0;

  var cartDrawer = document.querySelector('cart-drawer');
  if (!cartDrawer || !cartDrawer.getSectionsToRender) return;
  var sectionsToRender = battitoGetSections(cartDrawer);

  var action = null;
  if (!giftReached && freeQty > 0) {
    // Onder de drempel bestaat het gratis exemplaar nooit: altijd volledig
    // weg, ongeacht hoeveel stuks er (per ongeluk) zouden staan.
    action = 'remove';
  } else if (giftReached && freeQty > 1) {
    // Vangnet: er staat meer dan 1 gratis exemplaar terwijl de drempel wél
    // gehaald is (bv. via de losse /cart-pagina toch opgehoogd) -> terug
    // naar precies 1.
    action = 'clamp';
  } else if (paidQty === 0 && freeQty === 0 && !giftReached && giftDeclined) {
    action = 'reset-decline';
  } else if (freeQty === 0 && giftReached && !giftDeclined) {
    // Geldt zowel met 0 als met 1 of meer betaalde exemplaren al in de kar:
    // het gratis exemplaar komt er gewoon bij, betaald blijft ongemoeid.
    action = 'add';
  }
  if (!action) return;

  battitoSyncInProgress = true;

  var request;
  if (action === 'remove') {
    var removeUpdates = {};
    removeUpdates[freeVariantId] = 0;
    request = battitoCartUpdate(removeUpdates, { gift_origin: '', gift_declined: '' }, sectionsToRender);
  } else if (action === 'clamp') {
    var clampUpdates = {};
    clampUpdates[freeVariantId] = 1;
    request = battitoCartUpdate(clampUpdates, {}, sectionsToRender);
  } else if (action === 'reset-decline') {
    request = battitoCartUpdate({}, { gift_declined: '' }, sectionsToRender);
  } else {
    // add: gratis exemplaar erbij, betaalde exemplaren (0 of meer) blijven ongemoeid.
    request = battitoCartAdd(freeVariantId).then(function() {
      return battitoCartUpdate({}, { gift_origin: 'auto' }, sectionsToRender);
    });
  }

  request
    .then(function(response) { return battitoRender(cartDrawer, response); })
    .catch(function(error) { console.error('Fout bij synchroniseren cadeau:', error); })
    .then(function() { battitoSyncInProgress = false; }, function() { battitoSyncInProgress = false; });
}

document.addEventListener('DOMContentLoaded', battitoSyncGift);

var battitoGiftObserver = new MutationObserver(function() {
  battitoSyncGift();
});

function battitoStartGiftObserver() {
  var target = document.getElementById('CartDrawer');
  if (target) {
    battitoGiftObserver.observe(target, { childList: true, subtree: true });
  }
}

if (document.body) {
  battitoStartGiftObserver();
} else {
  document.addEventListener('DOMContentLoaded', battitoStartGiftObserver);
}
